import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router'
import { ParameterType } from '../interfaces/parameter'
import { ParametersService } from '../services/parameters.service'

@Injectable({
  providedIn: 'root',
})
export class SettingsResolver implements Resolve<ParameterType[]> {
  public params: Array<string> = [
    'PRIORITY',
    'SPEECH_LOCAL_ROOM',
    'TOTEM_CALENDAR',
    'SPEECH_PREV_PANEL',
    'SPEECH_NAME_PANEL',
    'TOTEM_DIMENSAO',
    'TOTEM_HISTORY',
    'TOTEM_USEPANELS',
    'TOTEM_PRINTER',
    'TOTEM_SKIP_PATIENT_DATA',
    'USAR_LOCAL',
    'MESSAGE_AFTER_CHECKIN',
    'EXIBITION_TYPE',
    'TOTEM_CHECKIN_CHANGES_STATUS',
  ]
  public varSys = 'USAR_LOCAL'

  constructor(
    private service: ParametersService,
    private router: Router,
    private parameterService: ParametersService
  ) {
    if (this.parameterService.appearanceEnabled === 'true') {
      this.params.push(
        'TEXT_FONT_FAMILY',
        'TEXT_COLOR',
        'PANEL_CLOCK_TEXT_COLOR',
        'PANEL_CLOCK_BACKGROUND_COLOR',
        'PANEL_LOGO_IMAGE_NAME',
        'PANEL_LOGO_IMAGE_URL',
        'TOTEM_BACKGROUND_TYPE',
        'TOTEM_BACKGROUND_IMAGE_NAME',
        'TOTEM_BACKGROUND_IMAGE_URL',
        'TOTEM_BACKGROUND_COLOR_PRIMARY',
        'TOTEM_BACKGROUND_COLOR_SECONDARY'
      )
    }
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.service.load(this.params)
  }
}
